/** Game EC2 host: public site is static HTML at /; only /admin + API use the SPA. */
export function isGameHost() {
    return typeof window !== "undefined" && window.location.hostname === "game.puzzleinteract.com";
}

/** After OAuth or auth guards, never land on SPA home (/) on the game host. */
export function normalizeAuthReturnPath(path) {
    const value = typeof path === "string" ? path.trim() : "";
    if (!isGameHost()) {
        return value || "/";
    }
    if (!value || value === "/" || !value.startsWith("/admin")) {
        return "/admin";
    }
    return value;
}
